<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar color="primary">
        <ion-title>Agenda</ion-title>
        <ion-buttons slot="start" auto-hide="false">
          <ion-menu-button>
            <ion-icon slot="end" :icon="chevronForwardSharp" />
          </ion-menu-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-loading
      :is-open="isOpenRef"
      message="Carregando informações..."
      :duration="timeout"
      @didDismiss="setOpen(false)"
    />

    <ion-content>
      <ion-segment :value="valueSegment" scrollable>
        <ion-segment-button
          v-for="(item, index) in arrDays"
          :key="index"
          :value="item"
          @click="orderValue(item, index)"
        >
          <ion-label id="segment-label">
            {{ dayjs(item).format("DD/MM") }}
          </ion-label>
        </ion-segment-button>
      </ion-segment>

      <ion-grid>
        <ion-row v-for="(item, index) in arrHours" :key="index">
          <ion-col class="hours" size="2" @click="goToDetailCalendar(item)">
            <ion-label>{{ item.start_time }}</ion-label> <br />
            <ion-label>{{ item.end_time }}</ion-label>
          </ion-col>

          <ion-col class="titles" size="8" @click="goToDetailCalendar(item)">
            <ion-label>{{ item.title }}</ion-label>
          </ion-col>

          <ion-col size="2">
            <ion-icon
              class="icon-star"
              size="large"
              :class="{ gold: item.is_colored }"
              :icon="item.is_colored ? star : starOutline"
              @click="setMySchedule(index)"
            />
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonContent,
  IonHeader,
  IonPage,
  IonLabel,
  IonTitle,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonLoading,
  IonSegment,
  IonIcon,
  IonSegmentButton,
  IonRow,
  IonCol,
  IonGrid,
} from "@ionic/vue";
import { defineComponent, ref } from "vue";

import { chevronForwardSharp, starOutline, star } from "ionicons/icons";
import dayjs from "dayjs";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "EventCalendar",
  components: {
    IonContent,
    IonHeader,
    IonPage,
    IonLabel,
    IonTitle,
    IonToolbar,
    IonButtons,
    IonMenuButton,
    IonLoading,
    IonSegment,
    IonIcon,
    IonSegmentButton,
    IonRow,
    IonCol,
    IonGrid,
  },
  beforeRouteEnter() {
    if (localStorage.getItem("reloaded")) {
      localStorage.removeItem("reloaded");
    } else {
      localStorage.setItem("reloaded", "1");
      location.replace("/event-calendar");
    }
  },
  props: {
    timeout: { type: Number, default: 1000 },
  },

  setup() {
    const isOpenRef = ref(false);
    const setOpen = (state) => (isOpenRef.value = state);
    const router = useRouter();
    return {
      dayjs,
      chevronForwardSharp,
      router,
      starOutline,
      isOpenRef,
      star,
      setOpen,
    };
  },

  data() {
    return {
      eventItem: {},
      arrHours: [],
      arrDays: [],
      valueSegment: null,
    };
  },
  created() {
    this.setOpen(true);

    const getObjEvent = localStorage.getItem("objEvent");
    this.eventItem = JSON.parse(getObjEvent);

    this.eventItem.activity.forEach((element) => {
      this.arrDays.push(element.date); // create array of dates
    });
    this.arrDays = [...new Set(this.arrDays)]; // remove  duplicates dates
    this.orderValue(this.arrDays[0]);
  },

  methods: {
    orderValue(date) {
      this.valueSegment = date;

      if (localStorage.getItem(`${this.eventItem.title}`)) {
        const parseArrFavorites = JSON.parse(
          localStorage.getItem(`${this.eventItem.title}`)
        );

        this.eventItem = parseArrFavorites;

        this.arrHours = [];

        this.eventItem.activity.forEach((element) => {
          if (element.date == date) {
            this.arrHours.push(element);
          }
        });
      } else {
        this.arrHours = [];

        this.eventItem.activity.forEach((element) => {
          if (element.date == date) {
            this.arrHours.push(element);
          }
        });
      }
    },
    goToDetailCalendar(item) {
      this.router.push({
        name: "DetailCalendar",
        params: { item: JSON.stringify(item) },
      });
    },

    setMySchedule(index) {
      this.arrHours[index].is_colored = this.arrHours[index].is_colored
        ? false
        : true;

      localStorage.setItem("objEvent", JSON.stringify(this.eventItem));
      localStorage.setItem(
        `${this.eventItem.title}`,
        JSON.stringify(this.eventItem)
      );
    },
  },
});
</script>

<style scoped>
ion-list {
  margin-top: 5px;
}

ion-row {
  display: flex;
  flex-wrap: nowrap !important;
}

ion-label {
  font-size: 16px;
}

#segment-label {
  font-size: 16px;
  font-weight: bold;
}
.container-hours {
  display: flex;
  gap: 20px;
  border-bottom: 1px solid #e8e4e4;
  padding: 20px;
}

ion-col {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

ion-segment {
  display: flex;
  justify-content: center;
}

.titles {
  align-self: center;
  width: 70% !important;
  padding-right: 20px;
  text-transform: uppercase;
}

.hours {
  color: var(--ion-color-primary);
  font-weight: 700;
  width: 15% !important;
  align-self: center;
}

.icon-star {
  font-size: 30px;
}

.gold {
  color: goldenrod;
}
</style>
